import React from "react";
import { InvoiceList } from "../invoice-list";
import { BannerProvider } from "../banner-provider/banner-provider";

export const InvoiceListView = () => {
  return (
    <BannerProvider>
      {(setBannerState) => (
        <div className="invoice-list-container">
          <InvoiceList setBannerState={setBannerState} />
        </div>
      )}
    </BannerProvider>
  );
};
